<script>
    export default {
        name: "FBreadcrumb",

        props: {
            divider: {
                type: String,
                default: "/"
            }
        },

        data: () => ({
            items: []
        }),

        mounted() {
            this.generateBreadcrumbItems();
        },

        watch: {
            $route() {
                this.generateBreadcrumbItems();
            }
        },

        methods: {
            capitalize(str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            },

            generateBreadcrumbItems() {
                const url = this.$route.path.split(/[?#]/)[0];
                const tokens = this.$route.path.split("/").filter(Boolean);
                tokens.unshift("");

                this.items = tokens.map((token, index, arr) => {
                    const isFirst = index == 0;
                    const isLast = index === arr.length - 1;

                    let to = arr.slice(0, index + 1).join("/");
                    let text = decodeURIComponent(token);

                    if (isFirst) {
                        to = "/";
                        text = "início";
                    }

                    return {
                        to,
                        text: this.capitalize(text),
                        disabled: isLast,
                        exact: true
                    };
                });
            }
        }
    };
</script>

<template>
    <v-breadcrumbs :items='items' :divider='divider'/>
</template>
